import Vue from 'vue';
import Router from 'vue-router';
import RegisterPage from '../pages/RegisterPage.vue';
import VerifyCode from '../pages/VerifyCode.vue';
import PasswordPage from '../pages/PasswordPage.vue';
import PolicyPage from '../pages/PolicyPage.vue';
import InfoPage from '../pages/InfoPage.vue';
import ForgotPasswordPage from '../pages/ForgotPasswordPage.vue';
import CreateNewPasswordPage from '../pages/CreateNewPasswordPage.vue';

Vue.use(Router);
export default new Router({
  routes: [
    {
      path: '/register/:token?',
      name: 'RegisterPage',
      component: RegisterPage,
      props: true,
    }, {
      path: '/verify/:phone/:token',
      name: 'VerifyPage',
      component: VerifyCode,
      props: true,
    }, {
      path: '/password/:phone/:token',
      name: 'PasswordPage',
      component: PasswordPage,
      props: true,
    }, {
      path: '/policy',
      name: 'PolicyPage',
      component: PolicyPage,
      props: true,
    }, {
      path: '/info',
      name: 'InfoPage',
      component: InfoPage,
      props: true,
    }, {
      path: '/forgot-password',
      name: 'ForgotPasswordPage',
      component: ForgotPasswordPage,
      props: true,
    }, {
      path: '/createNewPassword/:phone/:token',
      name: 'CreateNewPasswordPage',
      component: CreateNewPasswordPage,
      props: true,
    }, {
      path: '*',
      name: 'RegisterPage',
      component: RegisterPage,
    }
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js